import { useState } from "react";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary'
import { Typography, Grid, Box, TextField, FormControl, RadioGroup, Radio, FormLabel } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MultiSelectWithAll from "../../components/selections/multiSelectWithAll";
import SingleSelect from "../../components/selections/singleSelect";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import CustomButton from "../../components/buttons/customButton";
import { useEffect } from "react";



// {
//     name: "form-2",
//     fields: [
//         { id: 1, type: "text", name: "userName", label: "Name", required: true },
//         { id: 2, type: "text", name: "userEmail", label: "Email", required: true },
//         { id: 4, type: "check", name: "checkValue", label: "Check Box", required: true }

//     ]
// },
// {
//     name: "form-3",
//     fields: [
//         { id: 1, type: "text", name: "userName", label: "Name", required: true },
//         { id: 2, type: "text", name: "userEmail", label: "Email", required: true },
//     ]
// }, {
//     name: "form-4",
//     fields: [
//         { id: 1, type: "text", name: "userName", label: "Name", required: true },
//         { id: 2, type: "text", name: "userEmail", label: "Email", required: true },
//     ]
// },



const forms = [
    {
        name: "form-1",
        fields: [
            { id: 1, type: "text", name: "userName", label: "Name", maxLength: "30", required: true },
            { id: 2, type: "text", name: "userEmail", label: "Email", maxLength: "50", required: true },
            { id: 3, type: "number", name: "userNumber", label: "Number", maxLength: "10", required: true },

            {
                id: 3,
                type: "select",
                name: "organization",
                label: "Organizations",
                required: true,
                options: [
                    { value: 1, label: "Rizee Institute" },
                    { value: 2, label: "Narayana College" },
                    { value: 3, label: "Sri Chaitanya" },
                    { value: 4, label: "FIITJEE" },
                    { value: 5, label: "Resonance" },
                ],
            },
            {
                id: 4,
                type: "multi-select",
                name: "branchDepartmentValue",
                label: "branchDepartmentValue",
                required: true,

                options: [
                    { value: 1, label: "Rizee Institute" },
                    { value: 2, label: "Narayana College" },
                    { value: 3, label: "Sri Chaitanya" },
                    { value: 4, label: "FIITJEE" },
                    { value: 5, label: "Resonance" },
                ],
            },
            {
                id: 3,
                type: "radio",
                name: "radioValu",
                label: "gender",
                required: true,
                options: [
                    { id: 1, label: "M", value: "option1" },
                    { id: 2, label: "F", value: "option2" },
                ],
            },
            {
                id: 4,
                type: "check",
                name: "checkValue",
                label: "course",
                required: true,
                options: [
                    { id: 1, label: "html", value: "1" },
                    { id: 2, label: "css", value: "2" },
                ],
            },


        ]
    },

    {
        name: "form-2",
        fields: [
            { id: 1, type: "text", name: "userName", label: "Name", required: true },
            { id: 2, type: "text", name: "userEmail", label: "Email", required: true },
            { id: 4, type: "check", name: "checkValue", label: "Check Box", required: true }

        ]
    },
    {
        name: "form-3",
        fields: [
            { id: 1, type: "text", name: "userName", label: "Name", required: true },
            { id: 2, type: "text", name: "userEmail", label: "Email", required: true },
        ]
    }, {
        name: "form-4",
        fields: [
            { id: 1, type: "text", name: "userName", label: "Name", required: true },
            { id: 2, type: "text", name: "userEmail", label: "Email", required: true },
        ]
    },
]



export default function FormTab() {
    const [expanded, setExpanded] = useState(false);
    // const [checkField, updateCheckField] =useState("")

    const [formData, setFormData] = useState([]);
    const [panelIndex, setPanelIndex] = useState(null);


    const handleChange = (panel, val) => (event, isExpanded, index) => {
        setExpanded(isExpanded ? panel : false);
        setPanelIndex(val);
        let formFields = forms[val].fields;
        let storeForms = [];
        formFields.map((item) => {
            storeForms.push({ [item.name]: "" });
        });
        setFormData(storeForms)
    };

    const handleFieldChange = (formIndex, fieldName, value) => {
        setFormData((prev) => ({
            ...prev,
            [formIndex]: {
                ...prev[formIndex],
                [fieldName]: value,
            },
        }));
    };


    const handleSingleSelectChange = (panelIndex, fieldName, value) => {
        setFormData((prev) => ({
            ...prev,
            [panelIndex]: {
                ...prev[panelIndex],
                [fieldName]: value,
            },
        }));
    };

    return (
        <>
            <Grid>
                <Box>
                    {forms?.map((item, index) => (
                        <Accordion
                            key={index}
                            expanded={expanded === `panel${index}`}
                            onChange={handleChange(`panel${index}`, index)}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls={`panel${index}-content`}
                                id={`panel${index}-header`}
                            >
                                <Typography variant='h6' sx={{ width: '33%', flexShrink: 0 }}>
                                    {item.name}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Box>
                                    {<Grid container spacing={3}>
                                        {item?.fields.map((field, index) => (
                                            <>
                                                <Grid key={field.id} item size={{ xs: 12, md: 6 }} >
                                                    {field.type === "text" ? (
                                                        <TextField
                                                            size="small"
                                                            fullWidth
                                                            label={field.label}
                                                            required={field.required}
                                                            name={field.name}
                                                            value={formData[index]?.[field.name] ?? ""}                                                            // onChange={handleChange}
                                                            onChange={(e) => handleFieldChange(index, field.name, e.target.value)}
                                                            inputProps={{ maxLength: Number(field.maxLength) }}
                                                            error={Boolean(formData.errors?.[field?.name])}
                                                        />
                                                    ) : field.type === "number" ? (
                                                        <TextField
                                                            size="small"
                                                            fullWidth
                                                            label={field.label}
                                                            required={field.required}
                                                            name={field.name}
                                                            type="number"
                                                            value={formData[index]?.[field.name] ?? ""} onChange={(e) => {
                                                                const value = e.target.value;
                                                                if (/^\d*$/.test(value) && value.length <= Number(field.maxLength)) {
                                                                    handleFieldChange(index, field.name, e.target.value);
                                                                }
                                                            }}
                                                            inputProps={{ maxLength: Number(field.maxLength) }}
                                                            error={Boolean(formData.errors?.[field?.name])}
                                                        />
                                                    ) : field.type === "select" ? (
                                                        <SingleSelect
                                                            name={field.name}
                                                            label={field.label}
                                                            options={field.options}
                                                            value={formData[index]?.[field.name] || ""}
                                                            onChange={(selectedValue) =>
                                                                handleSingleSelectChange(index, field.name, selectedValue)
                                                            }
                                                            // onChange={handleSingleSelectChange}
                                                            // error={!!formData.errors[field.name]}
                                                            formHelperText={false}
                                                            required={field.required}

                                                        />
                                                    ) : field.type === "multi-select" ? (
                                                        <MultiSelectWithAll
                                                            name={field.name}
                                                            label={field.label}
                                                            options={field.options}
                                                            value={formData[field.name] || []}
                                                            // onChange={handleMultiSelectChange}
                                                            formHelperText={false}
                                                            // error={!!formData.errors[field.name]}
                                                            required={field.required}
                                                        />
                                                    ) : field.type === "radio" ? (
                                                        <FormControl>
                                                            <FormLabel sx={{ fontWeight: "bold", color: "black" }} >{field.label}</FormLabel>
                                                            <RadioGroup
                                                                row
                                                                name={field.name}
                                                                value={formData[field.name] || ""}
                                                                // onChange={handleChangeDetails}
                                                                required={field.required}
                                                            >
                                                                {field?.options?.map((opt) => (
                                                                    <FormControlLabel
                                                                        key={opt.id}
                                                                        value={opt.value}
                                                                        control={<Radio />}
                                                                        label={opt.label}
                                                                    />
                                                                ))}
                                                            </RadioGroup>
                                                        </FormControl>
                                                    ) : field.type === "check" ? (
                                                        <FormControl component="fieldset">
                                                            <FormLabel sx={{ fontWeight: "bold", color: "black" }}>{field.label}</FormLabel>
                                                            <FormGroup row
                                                                required={field.required}
                                                                // onChange={handleChangeDetails}
                                                                value={formData[field.name] || ""}
                                                            >
                                                                {field?.options?.map((opt) => (
                                                                    <FormControlLabel
                                                                        key={opt.id}
                                                                        control={
                                                                            <Checkbox
                                                                                name={opt.value}
                                                                            />
                                                                        }
                                                                        label={opt.label}
                                                                    />
                                                                ))}
                                                            </FormGroup>
                                                        </FormControl>
                                                    ) : null}

                                                </Grid>

                                            </>

                                        ))}


                                    </Grid>
                                    }

                                </Box>
                                <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                                    <CustomButton label="Submit" loadingLabel="Updating..." />
                                </Box>

                            </AccordionDetails>
                        </Accordion>

                    ))}
                </Box>
            </Grid>
        </>
    );
}